import type { GetDataModelsQuery, GetDataModelsResponse } from "./dataModels.types";
import { MOCK_LATENCY_MS } from "./dataModels.constants";
import {
  getMockListItems,
  getMockListResponse,
} from "./dataModels.mockStore";

export const mockFetchDataModels = async (
  query?: GetDataModelsQuery,
): Promise<GetDataModelsResponse> => {
  await new Promise((resolve) => setTimeout(resolve, MOCK_LATENCY_MS));

  let items = getMockListItems();
  const search = query?.search?.trim().toLowerCase();
  if (search) {
    items = items.filter(
      (item) =>
        item.name.toLowerCase().includes(search) ||
        item.description.toLowerCase().includes(search),
    );
  }
  if (query?.status) {
    items = items.filter((item) => item.status === query.status);
  }

  const limit = query?.limit ?? 50;
  const offset = query?.offset ?? 0;
  return getMockListResponse(items, limit, offset);
};

export const mockFetchDataModelsError = async (): Promise<never> => {
  await new Promise((resolve) => setTimeout(resolve, MOCK_LATENCY_MS));
  throw new Error("Failed to load data models.");
};
